import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["seat", "seatIdField", "selectedSeatDisplay", "confirmButton"]

  connect() {
    console.log("[SeatSelector] Controller connected")
  }

  selectSeat(event) {
    event.preventDefault()
    const seatButton = event.currentTarget
    const seatId = seatButton.dataset.seatId
    const seatNumber = seatButton.dataset.seatNumber
    const isAvailable = seatButton.dataset.available === "true"

    if (!isAvailable) {
      return
    }

    console.log("[SeatSelector] Selecting seat:", seatNumber, seatId)

    // Deselect all seats with smooth transition
    this.seatTargets.forEach(seat => {
      if (seat.dataset.available === "true") {
        seat.classList.remove("bg-indigo-500", "border-indigo-700", "text-white", "scale-105", "shadow-2xl")
        seat.classList.add("bg-green-100", "border-green-600", "text-green-900")
      }
    })

    // Select this seat with animation
    seatButton.classList.remove("bg-green-100", "border-green-600", "text-green-900")
    seatButton.classList.add("bg-indigo-500", "border-indigo-700", "text-white", "scale-105", "shadow-2xl")

    // Update hidden field
    this.seatIdFieldTarget.value = seatId

    // Update display with animation
    this.selectedSeatDisplayTarget.style.opacity = '0'
    setTimeout(() => {
      this.selectedSeatDisplayTarget.textContent = seatNumber
      this.selectedSeatDisplayTarget.style.transition = 'opacity 0.3s ease-in-out'
      this.selectedSeatDisplayTarget.style.opacity = '1'
    }, 150)

    // Enable confirm button with pulse animation
    this.confirmButtonTarget.disabled = false
    this.confirmButtonTarget.classList.add('animate-pulse')
    setTimeout(() => {
      this.confirmButtonTarget.classList.remove('animate-pulse')
    }, 1000)
  }
}
